import Header from "./Header/Header";
import OrdersGrid from "./OrdersGrid/OrdersGrid";

function OrderTracker() {
  return (
    <>
      <Header />
      <OrdersGrid />
    </>
  );
}

export default OrderTracker;